<template>
  <div class="glassmorphism-bg">
    <v-main>
      <v-container fluid class="pa-6">
        <!-- Header Card -->
        <div class="glassmorphism-card mb-6">
          <div class="d-flex justify-space-between align-center mb-4">
            <h2 class="page-title">Roles</h2>
          </div>

          <!-- Search Section -->
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field
                v-model="filter.search_keyword"
                label="Search roles..."
                prepend-inner-icon="mdi-magnify"
                outlined
                rounded
                dense
                clearable
                class="glassmorphism-input"
                @click:clear="(filter.search_keyword = null), (page = 1), getData()"
                @keydown.enter="(page = 1), getData()"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <!-- Data Table Card -->
        <div class="glassmorphism-card">
          <div v-if="isLoading" class="text-center py-12">
            <v-progress-circular
              indeterminate
              color="primary"
              size="64"
            ></v-progress-circular>
            <p class="text-h6 mt-4 text--secondary">Loading roles...</p>
          </div>

          <div v-else>
            <v-data-table
              :headers="headers"
              :items="roles"
              :items-per-page="rowsPerPage"
              :page="page"
              :server-items-length="count"
              hide-default-footer
              class="glassmorphism-table elevation-0"
            >
              <template v-slot:header="{ props }">
                <thead class="glassmorphism-table-header">
                  <tr>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'text-subtitle-2 font-weight-bold',
                        header.align === 'right' ? 'text-right' : 'text-left'
                      ]"
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                </thead>
              </template>

              <template v-slot:[`item.sr_no`]="{ index }">
                <span class="text-body-2 text--primary">{{ index + 1 }}</span>
              </template>

              <template v-slot:[`item.is_active`]="{ item }">
                <v-chip
                  small
                  :color="item.is_active == 1 ? 'success' : 'error'"
                  text-color="white"
                  class="glassmorphism-chip"
                >
                  <v-icon left size="16">
                    {{ item.is_active == 1 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>
                  {{ item.is_active == 1 ? 'Active' : 'Inactive' }}
                </v-chip>
              </template>

              <template v-slot:[`item.name`]="{ item }">
                <span class="text-body-1 font-weight-medium">{{ item.name || '' }}</span>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex justify-end">
                  <v-btn
                    icon
                    small
                    color="primary"
                    class="glassmorphism-icon-btn"
                    :to="`/roles/${encryptIt(item.id)}`"
                  >
                    <v-icon size="18">mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-slot:no-data>
                <div class="text-center py-8">
                  <v-icon size="64" color="grey lighten-1">mdi-account-supervisor</v-icon>
                  <p class="text-h6 mt-4 text--secondary">No roles found</p>
                  <p class="text-body-2 text--secondary">Try adjusting your search criteria</p>
                </div>
              </template>
            </v-data-table>

            <!-- Custom Pagination -->
            <div class="d-flex justify-center mt-6">
              <v-pagination
                v-model="page"
                :length="paginationLength"
                :total-visible="7"
                color="primary"
                class="glassmorphism-pagination"
              ></v-pagination>
            </div>
          </div>
        </div>

        <!-- Success Dialog -->
        <v-dialog v-model="is_deleted_role" width="600">
          <v-card rounded="xxl" class="glassmorphism-card">
            <v-container>
              <v-row align="center">
                <v-col sm="3" align="center">
                  <v-icon
                    large
                    style="color: green; font-size: 90px; width: 200px !important"
                  >
                    mdi-delete-empty
                  </v-icon>
                </v-col>
                <v-col sm="9" align="center">
                  <v-card-text>
                    <v-row>
                      <v-col>
                        <h1 style="color: green">Hurray!</h1>
                        <br />
                        <h3>Role deleted successfully.</h3>
                        <br />
                        <v-btn
                          color="success"
                          rounded
                          class="glassmorphism-btn"
                          @click="is_deleted_role = false"
                        >
                          OK
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import axios from "@/axios";
export default {
  name: "rolesPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
      },
      roles: [],
      headers: [
        { text: 'Sr No', value: 'sr_no', sortable: false, width: '10%' },
        { text: 'Status', value: 'is_active', sortable: false, width: '20%' },
        { text: 'Role', value: 'name', sortable: false, width: '50%' },
        { text: 'Actions', value: 'actions', sortable: false, align: 'right', width: '20%' }
      ],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportRoleTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
        Price: "price",
      },
      isLoading: false,
      isExcelloading: false,
      delete_role: false,
      is_deleted_role: false,
    };
  },
  watch: {
    page: "getData",
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active ? this.filter.is_active : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`roles?${query}`)
        .then((response) => {
          this.roles = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`role_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_role = true;
      await axios
        .post(`/roles/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_role = false;
          this.is_deleted_role = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
  },
};
</script>
